module.exports = __webpack_public_path__ + "img/9.fb2a31c6.jpg";